import { createIcon } from '@chakra-ui/react';

export const SocialYouTube = createIcon({
  displayName: `SocialYouTube`,
  viewBox: `0 0 36.002 26.19`,
  path: (
    <g
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="3px"
      transform="translate(.001 -4.5)"
    >
      <path
        id="Path_1525"
        d="M33.81 9.63a4.17 4.17 0 0 0-2.91-3C28.32 6 18 6 18 6S7.68 6 5.1 6.69a4.17 4.17 0 0 0-2.91 3 43.5 43.5 0 0 0-.69 7.935 43.5 43.5 0 0 0 .69 7.995A4.17 4.17 0 0 0 5.1 28.5c2.58.69 12.9.69 12.9.69s10.32 0 12.9-.69a4.17 4.17 0 0 0 2.91-3 43.5 43.5 0 0 0 .69-7.875 43.5 43.5 0 0 0-.69-8z"
      />
      <path id="Path_1526" d="M14.625 22.53l8.625-4.905-8.625-4.9z" />
    </g>
  ),
});
